import api from './api';

export const toolService = {
  macLookup: async (mac) => {
    const response = await api.get(`/tools/lookup/${mac}`);
    return response.data;
  },

  whoisLookup: async (ip) => {
    const response = await api.post('/tools/lookup/whois', { ip });
    return response.data;
  },

  executeCommand: async (command, host, port, username, password) => {
    const response = await api.post('/tools/execute', {
      command,
      host,
      port,
      username,
      password
    });
    return response.data;
  }
};